import { render, staticRenderFns } from "./brief-list.vue?vue&type=template&id=4936182a&scoped=true"
import script from "./brief-list.vue?vue&type=script&lang=js"
export * from "./brief-list.vue?vue&type=script&lang=js"
import style0 from "./brief-list.vue?vue&type=style&index=0&id=4936182a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4936182a",
  null
  
)

export default component.exports